module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/arrow-to-bottom-46f3244a2200a18e10cd4e96e8b0bcbf.svg";